import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';
import { ErrorInterceptor } from './error-interceptor';
import { StoreProvider } from './store.provider';

@NgModule()
export class ErrorModule {
  static forRoot(): ModuleWithProviders<ErrorModule> {
    return {
      ngModule: ErrorModule,
      providers: [
        {
          provide: APP_INITIALIZER,
          useFactory: (storeProvider: StoreProvider) => () => storeProvider.init(),
          deps: [StoreProvider],
          multi: true
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: ErrorInterceptor,
          multi: true
        }
      ]
    };
  }
}
